export default {
  orgId: '组织ID',
  orgName: '组织名称',
  orgType: '组织类型',
  terminalCount: '终端数',
  whitelistTerminalCount: '使用白名单终端数',
  whitelistTerminalCount2: '曾使用白名单终端数',
  terminalGroupCount: '分组数',
  searchPlaceholder: '组织名称',
  area: '地区',
  orgAdminRealName: '管理员数量',
  orgAdminPhoneNumber: '手机号',
  useDetail: '使用详情',
  handler: '操作',
  orgTypeName: {
    CUSTOMER: '客户',
    HEAD_OFFICE: '总机构',
    PARTNER: '合作伙伴'
  },
  orgInfoTitle: '组织信息',
  orgInfo: {
    orgIdTitle: '组织ID',
    orgNameTitle: '组织名称',
    orgTypeTitle: '组织类型',
    areaTitle: '地区',
    orgAdminUsernameTitle: '管理员',
    orgAdminPhoneNumberTitle: '管理员手机号',
    createTime: '创建时间'
  },
  whitelistInfoTitle: '白名单使用情况',
  softSituation: '软件使用情况',
  whiteOperation: '白名单web侧详情',
  yes: '是',
  no: '否',
  whitelistInfo: {
    terminalTotalCount: '终端总数',
    whitelistTerminalCount: '开启白名单终端数',
    whitelistTerminalPercent: '白名单终端占比',
    terminalGroupTotalCount: '总分组数',
    whitelistTerminalGroupCount: '开启白名单分组数',
    noAllowInstallTerminalGroupCount: '不允许软件安装分组数',
    closeWhitelistTerminalGroupCount: '关闭白名单分组数',
    whitelistFirstTime: '白名单首次使用时间',
    whitelistLastTime: '白名单最近操作时间',
    terminalDimension: '终端维度',
    terminalGroupMension: '终端组维度',
    noAllowInstallSituation: '不允许软件安装情况',
    timeSituation: '使用时间情况',
    terminalDesc: '总共{total}台终端，其中{open}台开启了白名单，占比{per}',
    terminalGroupDesc: '总共{total}个终端分组，其中{open}个分组开启了白名单，占比{per}',
    noAllowInstallDesc: '开启过白名单的{total}个终端分组中，有{notAllow}个分组不允许软件安装',
    timeDesc: '首次使用白名单时间：{firstTime}，最近操作白名单时间：{lastTime}'
  },
  whiteListGlobalConfigTitle: '应用到所有分组的模板',
  whiteListGlobalConfig: {
    allowGreen: '允许软件运行',
    whitelistSoftware: '允许软件列表',
    totalSoftware: '软件使用情况'
  },
  usingOrg: '白名单使用中的组织',
  losingOrg: '白名单流失的组织',
  softwareSituation: '（该组织的终端总共安装了{total}个软件，允许{allow}个软件运行{uninstall}）',
  softwareSituationAllow: '（该组织的终端总共安装了{total}个软件，所有软件均可运行）',
  softwareSituationAllow2: '（白名单已关闭，该组织的终端总共安装了{total}个软件）',
  uninstallSoft: '，其中{num}个已被阻止运行',
  unUseWhitelist: '（未收集到组织下软件信息）',
  openButNoSoftware: '（开启了软件管控但未设置白名单）',
  openTime: '白名单开启时间',
  closeTime: '白名单关闭时间',
  softControl: '软件运行管控',
  open: '开',
  close: '关',
  terminalWhiteListDtl: '白名单终端侧详情',
  stopInstall: '阻止了【{name}】软件的安装',
  stopRun: '阻止了【{name}】软件的运行',
  loadMore: '加载更多',
  noData: '暂无数据'
}
